import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../Containers/Config/index.js';
import {
  PAIN_MINUTES_DASHBOARD_CSRF_TOKEN,
  PAIN_MINUTES_DASHBOARD_CSRF_TOKEN_ERROR,
  PAIN_MINUTES_DASHBOARD_CSRF_TOKEN_SUCCESS,
} from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* painMinutesDashboardCSRFToken({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/security/csrf_token/`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: PAIN_MINUTES_DASHBOARD_CSRF_TOKEN_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: PAIN_MINUTES_DASHBOARD_CSRF_TOKEN_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: PAIN_MINUTES_DASHBOARD_CSRF_TOKEN_ERROR, payload: error });
  }
}

export function* watchPainMinutesDashboardCSRFToken() {
  yield takeEvery(PAIN_MINUTES_DASHBOARD_CSRF_TOKEN, painMinutesDashboardCSRFToken);
}

function* painMinutesDashboardCSRFTokenSaga() {
  yield all([fork(watchPainMinutesDashboardCSRFToken)]);
}

export default painMinutesDashboardCSRFTokenSaga;
